export const SETTINGS_ROUTES = {
	settings: "/settings",
} as const;
